module.exports = __webpack_public_path__ + "6a155ecc7c95f6515b553a2d2ae7c754.png";